import React, { memo, useCallback } from 'react'

import { Textarea } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func } from 'prop-types'

import useDisabledSelector from 'Pods/ThreeDStudio/Hooks/useDisabledSelector'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function TextInstructions({
  id,
  placeholder,
  sliceName,
  storeSchemaKey,
  setPrompt,
}) {
  const t = useTranslation()
  const prompt = useThreeDStudioStore(state => state[sliceName].prompt)
  const maxLength = useThreeDStudioStore(state =>
    state.schema?.[storeSchemaKey]?.input_schema?.properties?.prompt?.maxLength || undefined
  )
  const { isFullyDisabled } = useDisabledSelector('prompt', storeSchemaKey)

  const handleChange = useCallback((e) => {
    setPrompt(e.target.value)
  }, [])

  return (
    <div className="text-instructions">
      <Textarea
        id={`${id}-text-instructions`}
        placeholder={placeholder}
        rows={4}
        isPilot
        className="text-instructions__textarea"
        onChange={handleChange}
        value={prompt}
        isWarning={!isFullyDisabled && maxLength && prompt.length > maxLength}
        helpText={!isFullyDisabled && maxLength && prompt.length > maxLength
          ? t('shared.actionSelector.textInstructions.maxCharacters', { maxLength })
          : undefined
        }
        isDisabled={isFullyDisabled}
      />
    </div>
  )
}

TextInstructions.propTypes = {
  id: string.isRequired,
  placeholder: string.isRequired,
  sliceName: string.isRequired,
  storeSchemaKey: string.isRequired,
  setPrompt: func.isRequired,
}

export default memo(TextInstructions)
